import { cn } from '@frontdoor/ui/lib/utils';

import type { StatusView } from '@/pages/track/status-config.tsx';

import { OrderProgressBar } from './OrderProgressBar.tsx';
import { StatusBadge } from './StatusBadge.tsx';

type StatusBannerProps = {
  view: StatusView;
};

export function StatusBanner({ view }: StatusBannerProps) {
  return (
    <section className="mt-8 flex flex-col">
      {view.badge && (
        <div className="mb-2">
          <StatusBadge text={view.badge.text} variant={view.badge.variant} />
        </div>
      )}
      <h1 className="mb-2 text-xl leading-tight font-medium">{view.title}</h1>
      <p
        className={cn('whitespace-pre-line text-muted-foreground', view.showProgressBar && 'mb-8')}
      >
        {view.description}
      </p>
      {view.showProgressBar && (
        <div className="mb-2">
          <OrderProgressBar
            steps={view.steps}
            currentStepIndex={view.currentStepIndex}
            variant={view.progressVariant}
          />
        </div>
      )}
    </section>
  );
}
